import endpoints, { axios } from "../../config/api";

async function getGlobalFolder() {
  return await (await axios.get(endpoints.newfolders.global)).data;
}

export default getGlobalFolder;
